<template>
  <section class="application-form">
    <div class="application-form-container">
      <div class="application-form-content">
        <div class="application-form-wrapper">
          <div class="application-form-header">
            <h2 class="application-form-title">{{ t('index.contactForm.title') }}</h2>
            <p class="application-form-subtitle">{{ t('index.contactForm.subtitle') }}</p>
          </div>
          <ContactForm @submit="handleSubmit" />
        </div>
      </div>
      <div class="application-form-image">
        <picture>
          <img src="/assets/images/home-page/form/x1/cholovik-trymaie-bibliiu-knyha-khrest.jpg" srcset="/assets/images/home-page/form/x1/cholovik-trymaie-bibliiu-knyha-khrest.jpg 1x, /assets/images/home-page/form/x2/cholovik-trymaie-bibliiu-knyha-khrest.jpg 2x" alt="Чоловік у блакитній сорочці тримає в руці чорну книгу Біблію з золотим хрестом на обкладинці" width="480" height="360" loading="lazy" decoding="async">
        </picture>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const { t } = useI18n()

interface ContactFormData {
  fullName: string
  email: string
  locality?: string
  region?: string
  message?: string
  privacyAccepted?: boolean
}

const handleSubmit = (data: ContactFormData) => {
  // TODO: Implement form submission
  console.log('Form submitted:', data)
}
</script>

<style scoped>
.application-form {
  /* padding: 80px 0; */
  max-width: var(--max-width-container);
  margin: 0 auto;
}

.application-form-container {
  display: flex;
  align-items: stretch;
  gap: 85px;
  /* padding: 0 40px; */
  margin-top: 95px;;
}

.application-form-content {
  flex: 1;
  max-width: 600px;
  min-height: 580px;
}

.application-form-header {
  margin-bottom: 40px;
}

.application-form-title {
  font-family: var(--font-inter);
  font-weight: 700;
  font-size: 48px;
  line-height: 1.2;
  color: var(--color-dark-blue);
  margin-bottom: 16px;
}

.application-form-subtitle {
  font-family: var(--font-inter);
  font-size: var(--font-size-body);
  line-height: 1.6;
  color: var(--color-grey);
}


.application-form-image {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  align-self: stretch;
  padding-top: 10px;
  max-height: 785px;
}

.application-form-image picture {
  display: block;
  width: 100%;
  height: 100%;
}

.application-form-image img {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  object-fit: cover;
  object-position: right center;
}

@media (max-width: 1400px) {
  .application-form-container {
    padding: 0 60px;
  }
}

@media (max-width: 991px) {
  .application-form {
    padding: 60px 0;
  }

  .application-form-container {
    flex-direction: column;
    gap: 40px;
    padding: 0 30px;
    margin-top: 0;
  }

  .application-form-content {
    max-width: 100%;
    min-height: unset;
  }

  .application-form-title {
    font-size: 36px;
  }

  .application-form-image {
    order: -1;
    padding-top: 0;
  }

  .application-form-image img {
    max-width: 600px;
    display: none;
  }
}

@media (max-width: 767px) {
  .application-form {
    padding: 80px 0;
  }

  .application-form-container {
    padding: 0 20px;
  }

  .application-form-title {
    font-size: 28px;
  }

  .application-form-subtitle {
    font-size: var(--font-size-body);
  }
  .application-form-image {
    flex: none;
  }
}

@media (max-width: 575px) {
  .application-form-title {
    font-size: 24px;
  }
  .application-form-image {
    height: 400px;
  }
    .application-form-image img {
    max-width: 600px;
    display: block;
  }
}
@media (max-width: 480px) {
  .application-form-container {
    padding: 0 15px;
     gap: 20px;
     margin-top: 20px;
  }
  .application-form-title{
        font-size: 34px;
        margin-top: 4px;
        margin-bottom: 8px;
    }

}
</style>

